import React, { useEffect } from 'react';
import { AddFieldType } from './worksheet-form-component-edit-modal';
import { DraggableWorksheetFormComponent, WorksheetFormElementOption } from '@packages/models/api';
import { useValidationField } from './hooks/useValidationField';
import AddField from './add-field';
import colors from '@packages/core/styles/colors';

interface FormWorksheetEditTireWearProps extends DraggableWorksheetFormComponent {
    onChange({
        formElementLabel,
        options,
        worksheetElementTooltip,
        formElementDescription,
        formElementPlaceholder,
    }: {
        formElementLabel?: string;
        options?: WorksheetFormElementOption[] | undefined;
        worksheetElementTooltip?: string;
        formElementDescription?: string;
        formElementPlaceholder?: string | undefined;
    }): void;
    addField: AddFieldType;
    setIsValid: React.Dispatch<React.SetStateAction<boolean>>;
}

export const FormEditTireWear: React.FC<FormWorksheetEditTireWearProps> = ({
    formElementLabel,
    formElementTooltip,
    formElementDescription,
    onChange,
    addField,
    setIsValid,
}) => {
    const {
        fieldHandlers: { handleRequired },
        fieldErrorMessages,
        isValid,
    } = useValidationField();

    useEffect(() => {
        setIsValid(isValid);
    }, [isValid, setIsValid]);

    return (
        <>
            <AddField
                addFieldValues={addField}
                onchangeText={onChange}
                formElementTooltip={formElementTooltip}
                formElementDescription={formElementDescription}
                formElementLabel={formElementLabel}
                errorMessage={fieldErrorMessages?.questionLabel}
                handleRequired={handleRequired}
            />

            <hr style={{ borderWidth: 2, borderColor: colors.grayTwo }} />
        </>
    );
};
